// John Eldhose 20190430
import { RestfulGet } from './Restful';

export async function demoProducts() {
  const prods = await RestfulGet('demoProducts', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return prods;
}



// WEBPACK FOOTER //
// ./src/Api/demoProducts.js